import { render, staticRenderFns } from "./ApprovalNeeded.vue?vue&type=template&id=7c0a4713"
import script from "./ApprovalNeeded.vue?vue&type=script&lang=js"
export * from "./ApprovalNeeded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports